module.exports = __webpack_public_path__ + "img/Kundendialog_01_IK.4a8535f9.jpg";